import React, { useContext, useState, useRef, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  FlatList,
  SafeAreaView,
  DeviceEventEmitter,
  Platform,
  Dimensions,
} from "react-native";
import AppContext from "./context";
import { useColorScheme } from "react-native-appearance";
import Icon from "react-native-vector-icons/Ionicons";
import { colors } from "./context/Colors";
import MCQText from "./games/MCQText";
import GameModals from "./components/GameModals";
import Blanks from "./games/Blanks";
import MCQImage from "./games/MCQImage";
import Question from "./games/Question";
import TakePhoto from "./games/TakePhoto";
import * as Animatable from "react-native-animatable";
import StatsStack from "./pages/StatsStack";
import { ScrollView as DScrollView } from "dripsy";
import FindObject from "./games/FindObject";
import { useDeviceOrientation } from "@react-native-community/hooks";

export default function Challenges() {
  const {
    tour,
    stop,
    setStop,
    setTour,
    gameMenuHeight,
    inGameStats,
    setInGameStats,
    setAudioPlaying,
    setAudioFromCard,
    dict,
  } = useContext(AppContext);

  const [current, setCurrent] = useState(0);
  const challenges = useRef(tour.stops[stop] && tour.stops[stop].challenges ? tour.stops[stop].challenges : null);
  const gamesScrollRef = useRef();
  const [gameWidth, setGameWidth] = useState(Dimensions.get("window").width);
  const [modalType, setModalType] = useState("");
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const inGameStatsTop = useRef(50);
  const stopRef = useRef(stop);

  const orientation = useDeviceOrientation();
  useEffect(() => {
    setGameWidth(Dimensions.get("window").width);
    if(gamesScrollRef.current){
      gamesScrollRef.current.scrollToOffset({
        offset: current * Dimensions.get("window").width,
        animated: false,
      });
    }else{

    }
  }, [orientation]);

  const onSwipeGame = (position) => {
    setCurrent(Math.round(position / gameWidth));
  };
  console.log(inGameStatsTop.current);
  // console.log(tour.challengesWon, tour.challengesLost);

  useEffect(() => {
    if(!challenges.current){
      setInGameStats(true);
    }

    setAudioFromCard(-1);
    setAudioPlaying(false);
    DeviceEventEmitter.addListener("photo-done", answerPhoto);
    DeviceEventEmitter.addListener("magic-scanner-done", magicScannerDone);
    DeviceEventEmitter.addListener("magic-scanner-failed", magicScannerFailed);
    DeviceEventEmitter.addListener("switch-game-and-stop", switchGameAndStop);
    return () => {
      DeviceEventEmitter.removeListener("photo-done", answerPhoto);
      DeviceEventEmitter.removeAllListeners("magic-scanner-done");
      DeviceEventEmitter.removeAllListeners("magic-scanner-failed");
      DeviceEventEmitter.removeListener(
        "switch-game-and-stop",
        switchGameAndStop
      );
    };
  }, []);

  const switchGameAndStop = (newStop, newGame) => {
    console.log("switch to " + newStop + " " + newGame);
    setTimeout(() => {
      stopRef.current = newStop;
      if(newStop < 0 || tour.stops[newStop].challenges.length === 0) {
        setInGameStats(true);
      }else{
        challenges.current = tour.stops[newStop].challenges;
      }
      setCurrent(newGame);
      setStop(newStop);
      if (gamesScrollRef.current) {
        gamesScrollRef.current.scrollToOffset({
          offset: newGame * gameWidth,
          animated: false,
        });
      }
    }, 120);
  };

  const answerPhoto = () => {
    setModalType("afterPhoto");
  };

  const magicScannerDone = () => {
    setModalType("afterPhoto");
  };

  const magicScannerFailed = () => {
    setModalType("wrong");
  };

  const renderGame = (g) => {
    switch (g.challengeType) {
      case "MCQImage":
        return (
          <DScrollView
            style={{ width: gameWidth, paddingVertical: 20 }}
            sx={{ paddingHorizontal: [20, 40] }}
          >
            <MCQImage g={g} current={current} />
            <View style={{ height: 40 }} />
          </DScrollView>
        );

      case "MCQText":
        return (
          <DScrollView
            style={{ width: gameWidth, paddingVertical: 20 }}
            sx={{ paddingHorizontal: [20, 40] }}
          >
            <MCQText g={g} current={current} />
            <View style={{ height: 40 }} />
          </DScrollView>
        );

      case "Blanks":
        return (
          <DScrollView
            style={{ width: gameWidth, paddingVertical: 20 }}
            sx={{ paddingHorizontal: [20, 40] }}
          >
            <Blanks g={g} current={current} />
            <View style={{ height: 40 }} />
          </DScrollView>
        );

      case "Question":
        return (
          <DScrollView
            style={{ width: gameWidth, paddingVertical: 20 }}
            sx={{ paddingHorizontal: [20, 40] }}
          >
            <Question g={g} current={current} />
            <View style={{ height: 40 }} />
          </DScrollView>
        );

      case "TakePhoto":
        return (
          <DScrollView
            style={{ width: gameWidth, paddingVertical: 20 }}
            sx={{ paddingHorizontal: [20, 40] }}
          >
            <TakePhoto g={g} current={current} />
            <View style={{ height: 40 }} />
          </DScrollView>
        );

      case "FindObject":
        return (
          <DScrollView
            style={{ width: gameWidth, paddingVertical: 20 }}
            sx={{ paddingHorizontal: [20, 40] }}
          >
            <FindObject g={g} current={current} answer={() => answer(g)} />
            <View style={{ height: 40 }} />
          </DScrollView>
        );

      default:
        return (
          <View style={{ width: gameWidth }}>
            <Text
              style={{
                color: colors[theme].text,
                textAlign: "center",
                padding: 20,
              }}
            >
              Game type not supported yet. :(
            </Text>
          </View>
        );
    }
  };

  const switchGame = (k) => {
    setCurrent(k);
    if (gamesScrollRef.current) {
      gamesScrollRef.current.scrollToOffset({
        offset: k * gameWidth,
        animated: true,
      });
    }
  };
  const answer = (g) => {
    // console.log(g);
    let correct = false;
    switch (g.challengeType) {
      case "MCQImage":
      case "MCQText":
        //Check is it required to give multiple answers
        if (g.propositions.filter((p) => p.flag).length > 1) {
          correct = true;
          g.propositions.some((p) => {
            if (!p.hasOwnProperty("checked")) p.checked = false;
            if (p.checked !== p.flag) {
              correct = false;
              return true;
            }
          });
        } else {
          g.propositions.some((p) => {
            if (p.checked && p.flag) {
              correct = true;
              return true;
            }
            return false;
          });
        }
        break;
      case "Blanks":
        // console.log(
        //   g.answer.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        //   g.goodAnswer.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        // );
        correct =
          g.answer
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") ===
          g.goodAnswer
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        break;
      case "Question":
        g.propositions.some((p) => {
          if (p.text.toLowerCase() === g.answer.trim().toLowerCase()) {
            correct = true;
            return true;
          }
          return false;
        });
        break;
      case "FindObject":
      case "TakePhoto":
        correct = true;
        break;
    }

    if (correct) {
      g.state = "correct";
      setModalType("correct");
    } else {
      g.maxNumberOfAttempts--;
      if (g.maxNumberOfAttempts) {
        if(g.challengeType != "Blanks"){
          g.propositions.forEach((p) => {
            delete p.checked;
            delete p.answer;
          });
          g.state = "";
          delete g.answer;
        }
      } else {
        g.state = "failed";
      }
      setModalType("wrong");
    }
    setTour({ ...tour });
  };

  const skip = (g) => {
    g.propositions.forEach((p) => {
      delete p.checked;
    });
    g.state = "failed";
    setTour({ ...tour });
    setModalType("skip");
  };

  const skipAsk = () => {
    if(challenges.current[current].challengeType === "TakePhoto" || challenges.current[current].challengeType === "FindObject" ){
      skip(challenges.current[current]);
    }else{
      setModalType("skipAsk");
    }
    
  };

  const nextModal = () => {
    setModalType("");
    if (modalType === "correct" || modalType === "afterPhoto") {
      saveScores(challenges.current[current].score, true);
      collectInventory();
    }
    if (modalType === "skip") {
      saveScores(0);
      if (challenges.current[current].challengeType !== "TakePhoto")
        correctAnswerWas();
      else {
        if (challenges.current[current].giveObjectOnFailure) collectInventory();
        else didYouKnow();
      }
    }
    if (
      modalType === "wrong" &&
      !challenges.current[current].maxNumberOfAttempts
    ) {
      saveScores(0);
      if (
        challenges.current[current].challengeType != "FindObject" &&
        challenges.current[current].giveAnswerOnFailure
      ) {
        correctAnswerWas();
      } else {
        if (challenges.current[current].giveObjectOnFailure) collectInventory();
        else didYouKnow();
      }
    }
    if (modalType === "correctAnswerWas") {
      if (challenges.current[current].giveObjectOnFailure) collectInventory();
      else didYouKnow();
    }
    if (modalType === "inventory") {
      didYouKnow();
    }
    if (modalType === "didYouKnow") {
      goToNext();
    }
  };

  const collectInventory = () => {
    if (challenges.current[current].objectType !== "None") {
      setTimeout(() => {
        setModalType("inventory");
        const obj = {
          objectType: challenges.current[current].objectType,
          objectBlobReference: challenges.current[current].objectBlobReference,
          objectName: challenges.current[current].objectName,
          enablePhotoWithObject:
            challenges.current[current].enablePhotoWithObject,
          objectDescription: challenges.current[current].objectDescription,
          objectShortDescription:
            challenges.current[current].objectShortDescription,
          time: +new Date(),
          fromStop: stop,
        };
        switch (challenges.current[current].objectType) {
          case "Object":
          case "Audio":
          case "Text":
            tour.inventory.push(obj);
            tour.badgeInventory++;
            break;
          case "Letter":
            tour.letters.some((o, i) => {
              if (o.objectName === "?") {
                tour.letters[i] = obj;
                return true;
              }
              return false;
            });
            tour.letters.forEach((l, i) => (l.key = String(i)));
            tour.badgeLetter++;
            break;
          case "Puzzle":
            tour.puzzles.some((o, i) => {
              if (o.objectName === "?") {
                tour.puzzles[i] = obj;
                return true;
              }
              return false;
            });
            tour.puzzles.forEach((l, i) => (l.key = String(i)));
            tour.badgePuzzle++;
            break;
        }

        setTour({ ...tour });
      }, 100);
    } else {
      didYouKnow();
    }
  };

  const correctAnswerWas = () => {
    setTimeout(() => {
      setModalType("correctAnswerWas");
    }, 100);
  };

  const didYouKnow = () => {
    if (challenges.current[current].answerComplementMessage) {
      setTimeout(() => {
        setModalType("didYouKnow");
      }, 100);
    } else {
      goToNext();
    }
  };

  const goToNext = () => {
    setModalType("");

    if (tour.totalChallenges === tour.challengesWon + tour.challengesLost) {
      setModalType("final");
      return false;
    }
    if (tour.stops[stop].challenges[current].state === "correct") {
      if (tour.stops[stop].challenges[current + 1]) switchGame(current + 1);
      else window.parent.postMessage("closeGame", '*');
    }
  };

  const goToNextButton = () => {
    console.log("goToNextButton");
    if (tour.stops[stop].challenges[current + 1]) switchGame(current + 1);
    else window.parent.postMessage("closeGame", '*');
  };

  const saveScores = (score, won) => {
    tour.totalScore = tour.totalScore + score;
    if (won) tour.challengesWon++;
    else tour.challengesLost++;

    const finishedChallenges = tour.stops[stop].challenges.filter(
      (c) => c.state === "failed" || c.state === "correct"
    ).length;
    if (tour.stops[stop].challenges.length === finishedChallenges) {
      tour.unlockedStop = stop + 1;
    }
    setTour({ ...tour });
  };

  return (
    <View
      style={{
        backgroundColor: colors[theme].bg,
        flex: 1,
      }}
    >
      {challenges.current && 
      <>
      <SafeAreaView>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          onLayout={(e) =>
            (inGameStatsTop.current =
              e.nativeEvent.layout.y + e.nativeEvent.layout.height)
          }
        >
          <div />
          {/* <TouchableOpacity
            onPress={() => navigation.goBack()}
            style={{ padding: 15, paddingLeft: 8 }}
          >
            <Icon name="chevron-back" size={34} color={colors[theme].text} />
          </TouchableOpacity> */}
          <TouchableOpacity
            onPress={() => setInGameStats(true)}
            style={{
              position: "absolute",
              width: 100,
              left: "50%",
              marginLeft: -50,
            }}
          >
            <View>
              <Text
                style={{ color: "#9C9C9C", textAlign: "center", fontSize: 10 }}
              >
                {dict.score}
              </Text>
              <Text
                style={{
                  color: "#26C97A",
                  textAlign: "center",
                  fontSize: 21,
                  fontWeight: "700",
                  marginTop: -3,
                }}
              >
                {tour.totalScore}
              </Text>
            </View>
          </TouchableOpacity>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <TouchableOpacity
              style={{ padding: 13 }}
              disabled={current === 0}
              onPress={() => switchGame(current - 1)}
            >
              <Icon
                name="chevron-back"
                size={22}
                style={{
                  opacity: current === 0 ? 0.3 : 1,
                }}
                color={colors[theme].text}
              />
            </TouchableOpacity>
            <Text style={{ fontWeight: "bold", color: colors[theme].text }}>
              {current + 1}{" "}
              <Text style={{ opacity: 0.4 }}>
                {dict.of} {challenges.current.length}
              </Text>
            </Text>
            <TouchableOpacity
              style={{ padding: 13 }}
              disabled={current === challenges.current.length - 1}
              onPress={() => switchGame(current + 1)}
            >
              <Icon
                name="chevron-forward"
                size={22}
                style={{
                  opacity: current === challenges.current.length - 1 ? 0.3 : 1,
                }}
                color={colors[theme].text}
              />
            </TouchableOpacity>
          </View>
        </View>
      </SafeAreaView>
      <View style={{ flex: 1 }}>
        <FlatList
          horizontal
          pagingEnabled
          snapToAlignment="start"
          showsHorizontalScrollIndicator={false}
          keyExtractor={(item) => String(item.challengeID)}
          data={challenges.current}
          renderItem={({ item, index }) => {
            return (
              <div
                style={{ maxHeight: "calc(100vh - 160px)", overflow: "auto" }}
              >
                {renderGame(item)}
              </div>
            );
          }}
          ref={gamesScrollRef}
          getItemLayout={(data, index) => ({
            length: gameWidth,
            offset: gameWidth * index,
            index,
          })}
          onMomentumScrollEnd={(e) =>
            onSwipeGame(e.nativeEvent.contentOffset.x)
          }
          initialScrollIndex={current}
        />
      </View>
      {/* <Text onPress={() => setModalType('final')} style={{ color: '#F00' }}>
        Test wining modal
      </Text> */}
      <SafeAreaView>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-evenly",
            backgroundColor: colors[theme].gameButtonBg,
            shadowColor: "#000",
            position: "relative",
            shadowOffset: {
              width: 2,
              height: -5,
            },
            shadowOpacity: 0.05,
            shadowRadius: 2.62,
            elevation: 4,
          }}
        >
          {challenges.current[current].state !== "failed" &&
          challenges.current[current].state !== "correct" ? (
            <TouchableOpacity
              style={{ padding: 10 }}
              onPress={() => skipAsk()}
              disabled={
                challenges.current[current].state === "failed" ||
                challenges.current[current].state === "correct"
              }
            >
              <View
                style={{
                  opacity:
                    challenges.current[current].state === "failed" ||
                    challenges.current[current].state === "correct"
                      ? 0.5
                      : 1,
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                    color: colors[theme].text,
                  }}
                >
                  {dict.skip}
                </Text>
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 12,
                    color: "#9c9c9c",
                  }}
                >
                  {dict.win_no_point}
                </Text>
              </View>
            </TouchableOpacity>
          ) : null}
          {challenges.current[current].challengeType !== "TakePhoto" &&
          challenges.current[current].challengeType !== "FindObject" &&
          challenges.current[current].state !== "failed" &&
          challenges.current[current].state !== "correct" ? (
            <TouchableOpacity
              style={{ padding: 10 }}
              disabled={challenges.current[current].state !== "can-answer"}
              onPress={() => answer(challenges.current[current])}
            >
              <View
                style={{
                  opacity:
                    challenges.current[current].state === "can-answer"
                      ? 1
                      : 0.5,
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                    color: "#26C97A",
                  }}
                >
                  {dict.answer}
                </Text>
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 12,
                    color: "#9c9c9c",
                  }}
                >
                  {dict.win} {challenges.current[current].score}
                </Text>
              </View>
            </TouchableOpacity>
          ) : null}
          {challenges.current[current].state === "failed" ||
          challenges.current[current].state === "correct" ? (
            <TouchableOpacity
              style={{ padding: 10 }}
              onPress={() => goToNextButton()}
            >
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 18,
                  fontWeight: "bold",
                  color: colors[theme].text,
                }}
              >
                {dict.next}
              </Text>
              <Text
                style={{ textAlign: "center", fontSize: 12, color: "#9c9c9c" }}
              >
                {" "}
              </Text>
            </TouchableOpacity>
          ) : null}
        </View>
      </SafeAreaView>
      </>
    }
      {modalType ? (
        <GameModals
          g={challenges.current[current]}
          show={modalType}
          next={nextModal}
          skip={() => skip(challenges.current[current])}
          cancel={() => setModalType("")}
        />
      ) : null}
      {inGameStats && (
        <>
          <View
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1000000000,
              backgroundColor: colors[theme].bg08,
            }}
          >
            <TouchableOpacity
              style={{ width: "100%", height: "100%" }}
              onPress={() => setInGameStats(false)}
            />
          </View>
          <Animatable.View
            animation={"fadeInUp"}
            duration={600}
            style={{
              backgroundColor: colors[theme].bg,
              position: "absolute",
              top: inGameStatsTop.current,
              left: "5%",
              width: "90%",
              height: gameMenuHeight,
              borderRadius: 10,
              shadowColor: "#000",
              shadowOffset: {
                width: 0,
                height: 5,
              },
              shadowOpacity: 0.34,
              shadowRadius: 6.27,
              elevation: 10,
              zIndex: 1000000000,
            }}
          >
            <View
              style={{
                backgroundColor: colors[theme].bg,
                width: 16,
                height: 16,
                position: "absolute",
                top: -6,
                left: "50%",
                marginLeft: -8,
                transform: [{ rotate: "45deg" }],
              }}
            />
            <View style={{ borderRadius: 10, overflow: "hidden", flex: 1 }}>
              <StatsStack />
            </View>
          </Animatable.View>
        </>
      )}
    </View>
  );
}
